import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import * as AppointmentReducer from '../../actions/Appointment.js';
import * as GetCabinet from '../../actions/GetCabinet.js';
import TableHeadItem from "./TableHeadItem";
import TableRow from "./row";

const WEEK = {
    "0": "Понедельник",
    "1": "Вторник",
    "2": "Среда",
    "3": "Четверг",
    "4": "Пятница",
    "5": "Суббота",
    "6": "Воскресенье"

}

export class AppointmentTable extends Component {
    constructor() {
        super();
    
        this.state = {
            dates: [],
            schedules: [],
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.dates && nextProps.schedules) {
            this.setState({
                dates: nextProps.dates.length > 0 ? nextProps.dates[Number(nextProps.cabinetIndex)] : [],
                schedules: nextProps.schedules.length > 0 ? nextProps.schedules[Number(nextProps.cabinetIndex)] : [],
            })
        }
    }

    onChange = (event) => {
        const select = event.target
        const id = select.children[select.selectedIndex].id;
        this.props.setCabinet.GetCabinet({cabinetId: id, cabinetIndex: event.target.value})
    }

    render(){
        const dates = this.props.dates && this.props.dates.length === 1 ?  this.props.dates[0] : []
        const sedules = this.props.schedules && this.props.schedules.length === 1 ? this.props.schedules[0] : []
        return (
            <div>
                {this.props.cabinetName && this.props.cabinetName.length > 1 ?
                <div>
                    <div className="content_cabinets">
                        <div>
                            <h4>Кабинет</h4>
                            <select value={this.props.cabinetIndex} onChange={this.onChange} >
                                {this.props.cabinetName.map((cabinetName, index) => {
                                    return (
                                        <option key={index} onClick={this.onClick} id={cabinetName.cabinetId} value={index}>{cabinetName.cabinetName}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div style={{margin: '20px'}}>
                        <table style={{width: "100%"}}>
                            <tbody>
                                <tr className="table__header">
                                    {this.state.dates && this.state.dates.map((date, index) => (
                                    <TableHeadItem
                                            key={index}
                                            dayWeek={WEEK[index]}
                                            date={date}
                                        />
                                    ))}
                                </tr>
                                {this.state.schedules && this.state.schedules.map((row, index) => (
                                    <TableRow key={index} row={row} />
                                ))}
                            </tbody>
                        </table>
                    </div>  
                </div>
                :
                <div style={{margin: '20px'}}>
                    <table style={{width: "100%"}}>
                        <tbody>
                            <tr className="table__header">
                                {dates.map((date, index) => (
                                <TableHeadItem 
                                        key={index} 
                                        dayWeek={WEEK[index]} 
                                        date={date} 
                                    />
                                ))}
                            </tr>
                            {sedules.map((row, index) => (
                                <TableRow key={index} row={row} />
                            ))}
                        </tbody>
                    </table>
                </div>
                }
            </div>
        )
    }
}


function mapStateToProps(state) {
    return {
        offset: state.AppointmentReducer.offset,
        schedules: state.AppointmentReducer.schedules,
        dates: state.AppointmentReducer.dates,
        cabinetName: state.AppointmentReducer.cabinetName,
        cabinetId: state.GetCabinet.cabinetId,
        cabinetIndex: state.GetCabinet.cabinetIndex
    }
}

function mapDispatchToProps(dispatch) {
    return {
        schedule: bindActionCreators(AppointmentReducer, dispatch),
        setCabinet: bindActionCreators(GetCabinet, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentTable);



// WEBPACK FOOTER //
// frontend/src/modules/appointment-table/index.jsx